import { useQuery } from "@tanstack/react-query";
import { Fragment, useEffect, useState } from "react";
import { Modal, Table } from "react-bootstrap";
import Laoding from "../../../../../components/Loading";
import PaginateCard from "../../../../../components/PaginateCard";
import { getByAuthService } from "../../../../../function/helper";
import dateTimeToJalali from "../../../../../function/jalali/dateTimetoJalali";
import style from "./WalletRequestForm.module.css";

function CodList({ close, set }) {
  const [paginate, setPaginate] = useState({
    items: 10,
    page: 1,
  });

  const { data, isFetching, refetch } = useQuery({
    queryKey: ["codList"],
    queryFn: () =>
      getByAuthService("/myaccount/v1/user/codList", paginate).then(res => {
        if (res && res.status === 200) {
          return res.data.result;
        }

        return [];
      }),
    refetchOnWindowFocus: false,
    retry: 0,
    enabled: false,
  });

  useEffect(() => {
    refetch();
  }, [paginate.page]);

  return (
    <Modal
      show={true}
      centered={true}
      size="xl"
      className={[style.modal, style.codModal].join(" ")}
    >
      <Modal.Header>
        <h5>لیست مرسولات پرداخت در محل-COD که تحویل گیرنده شده‌اند</h5>
      </Modal.Header>

      <Modal.Body className="d-flex flex-column">
        <p className="m-0">برای انتخاب روی مرسوله مورد نظر کلیک کنید</p>
        <div className="w-100 px-1 overflow-x-auto flex-grow-1">
          <Table striped={true} bordered={true}>
            <thead>
              <tr>
                <th>ردیف</th>
                <th>شماره سفارش</th>
                <th>فرستنده</th>
                <th>گیرنده</th>
                <th>مبلغ COD با احتساب کارمزد (ریال)</th>
                <th>تاریخ</th>
              </tr>
            </thead>
            <tbody>
              {isFetching && (
                <tr>
                  <td colSpan="6">
                    <Laoding />
                  </td>
                </tr>
              )}
              {isFetching === false &&
                data?.items?.map((item, idx) => (
                  <tr
                    key={item.id}
                    className={[
                      style.trHover,
                      "c-pointer",
                      "align-middle",
                    ].join(" ")}
                    onClick={() => {
                      set({
                        numberParcel: item.numberParcel,
                        amount:
                          item.cod_wage !== null
                            ? item.cod_wage?.amount
                            : item.cod_flow?.amount,
                        id: item.id,
                      });
                      close();
                    }}
                  >
                    <td>{idx + 1 + (paginate.page - 1) * paginate.items}</td>
                    <td>{item.numberParcel}</td>
                    <td>
                      {item.source.type === 0 ? (
                        <Fragment>
                          <span>{item.source.name}</span>
                          <span> {item.source.family}</span>
                        </Fragment>
                      ) : (
                        <span>{item.source.compony}</span>
                      )}
                    </td>
                    <td>
                      <span>{item.destination.province.faName} </span>
                      <span>{item.destination.city.faName} - </span>
                      {item.destination.type === 0 ? (
                        <Fragment>
                          <span>{item.destination.name}</span>
                          <span> {item.destination.family}</span>
                        </Fragment>
                      ) : (
                        <span>{item.destination.compony}</span>
                      )}
                    </td>
                    <td>
                      {item.cod_wage !== null ? (
                        <span>{item.cod_wage?.amount.toLocaleString()}</span>
                      ) : (
                        <span>{item.cod_flow?.amount.toLocaleString()}</span>
                      )}
                    </td>
                    <td>{dateTimeToJalali(item.created_at).full}</td>
                  </tr>
                ))}
            </tbody>
          </Table>
        </div>

        <PaginateCard
          count={data?.count}
          numberItems={paginate.items}
          numberPage={paginate.page}
          onIndexChoose={page => setPaginate(cur => ({ ...cur, page }))}
        />
      </Modal.Body>

      <Modal.Footer>
        <button onClick={close} className="btn btn-danger">
          بستن
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default CodList;
